import ApperIcon from '@/components/ApperIcon';

// The navy RESULT strip of the printed canvas: what the canvas worked out from the answers.
export default function ResultStrip({ results, values }) {
  if (!results || results.length === 0) return null;
  return (
    <section aria-label="Results" className="overflow-hidden rounded-2xl bg-sidebar text-sidebar-foreground shadow-md">
      <div className="flex items-center gap-2 border-b border-sidebar-border px-4 py-2.5 md:px-5">
        <ApperIcon name="Calculator" size={16} className="text-highlight" />
        <h3 className="font-heading text-sm font-semibold uppercase tracking-wide">Result</h3>
        <span className="text-xs opacity-70">worked out for you, and sent on to the next canvases</span>
      </div>
      <dl className="grid grid-cols-[repeat(auto-fit,minmax(11rem,1fr))] gap-px bg-sidebar-border">
        {results.map((r) => {
          const val = values?.[r.id];
          const has = val !== undefined && val !== null && String(val).trim() !== '';
          return (
            <div key={r.id} className="space-y-1 bg-sidebar px-4 py-3.5 md:px-5">
              <dt className="text-[11px] font-semibold uppercase tracking-wider opacity-75">{r.label}</dt>
              <dd className={has ? 'font-heading text-xl font-semibold leading-tight text-highlight' : 'font-heading text-xl leading-tight opacity-40'}>
                {has ? String(val) : '-'}
              </dd>
              {r.rule && <p className="text-[11px] leading-snug opacity-70">{r.rule}</p>}
            </div>
          );
        })}
      </dl>
    </section>
  );
}
